module.exports = __webpack_public_path__ + "img/1.c76053ad.png";